import { __rest } from "tslib";
import React from 'react';
import BodyText from '../BodyText';
const Preamble = (_a) => {
    var { Tag = 'p', className, children } = _a, props = __rest(_a, ["Tag", "className", "children"]);
    return (React.createElement(BodyText, Object.assign({ Tag: Tag, className: className, preamble: true }, props), children));
};
export default Preamble;
//# sourceMappingURL=Preamble.js.map